import type { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  root: {
    paddingTop: 0,
  },
  gridWrapper: {
    // Scoped overrides for the Current grid/card only
    position: "relative",
    "& .MuiPaper-root.MuiCard-root": {
      boxShadow: "none !important",
      border: "0 !important",
      borderBottom: "0 !important",
      backgroundColor: "transparent !important",
    },
    "& .MuiDataGrid-root": {
      border: "0 !important",
      boxShadow: "none !important",
    },
    "& .MuiDataGrid-main, & .MuiDataGrid-columnHeaders, & .MuiDataGrid-virtualScroller, & .MuiDataGrid-viewport":
      {
        borderBottom: "0 !important",
      },
    // Add a tiny overlay to visually mask any remaining 1-2px lines at the bottom
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "4px",
      backgroundColor: theme.palette.background.paper,
      pointerEvents: "none",
      zIndex: 2,
    },
  },
  input: {
    padding: 0,
    maxHeight: 25,
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    boxShadow: "none",
    "&:focus-within": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
    "& .MuiInput-input": {
      paddingLeft: "4px",
      paddingTop: "2px",
      paddingBottom: "2px",
      fontSize: 13,
      height: 16,
    },
  },
  error: {
    color: theme.palette.redAlert.main,
    paddingLeft: 5,
  },
  inputContainer: {
    display: "contents",
  },
  inputError: {
    padding: 0,
    maxHeight: 25,
    borderRadius: "4px",
    boxShadow: "none",
    border: `2px solid ${theme.palette.redAlert.main}`,
    "& .MuiInput-input": {
      paddingLeft: "4px",
      paddingTop: "2px",
      paddingBottom: "2px",
      fontSize: 13,
      height: 16,
    },
  },
});

export default styles;
